import { Chip, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from "@material-ui/core";
import { blue, blueGrey, green, lightGreen, orange, red } from "@material-ui/core/colors";
import { DataGrid } from "@material-ui/data-grid";
import {
  Android,
  Apple,
  BatteryChargingFull,
  Cancel,
  Check,
  CheckCircleOutline,
  DeviceUnknownOutlined,
  Error,
  ErrorOutline,
  ErrorOutlined,
  FilterNone,
  FlashOn,
  GpsFixed,
  HighlightOffOutlined,
  Home,
  InfoOutlined,
  LocationCityOutlined,
  LocationOff,
  LocationOn,
  LocationSearching,
  NotListedLocation,
  NotListedLocationOutlined,
  Warning,
  Whatshot,
} from "@material-ui/icons";
import moment from "moment";
import React from "react";

const columns = [
  { field: "state", headerName: "Estado", width: 150 },
  { field: "uid", headerName: "UID" },
  { field: "LocationEnabled", headerName: "Ubicación" },
];

const ROWVALUES = {
  ACCESS_BACKGROUND_LOCATION: { granted: <Check />, undefined: "--" },
  ACCESS_FINE_LOCATION: { granted: <Check />, undefined: "--" },
  WHITELIST: { true: <Whatshot />, false: "", undefined: "--" },
  enableHighAccuracy: { true: <GpsFixed />, false: <LocationSearching />, undefined: "--" },
  OS: { android: <Android style={{ color: lightGreen[300] }} />, ios: <Apple />, undefined: <DeviceUnknownOutlined /> },
  LOCATION_ENABLED: {
    true: (located, position) => {
      //console.log(typeof position);
      return (
        <Tooltip title={typeof position === "object" ? `x:${position.coords.latitude} y:${position.coords.longitude} a:${position.coords.accuracy}` : position}>
          <LocationOn style={{ color: located ? green[500] : orange[500] }} />
        </Tooltip>
      );
    },
    false: () => <LocationOff style={{ color: red[500] }} />,
  },
  STATE: {
    0: <Chip variant="outlined" size="small" style={{ color: red[500], borderColor: red[500] }} icon={<HighlightOffOutlined style={{ color: red[500] }} />} label={"error"} />,
    1: <Chip variant="outlined" size="small" style={{ color: green[500], borderColor: green[500] }} icon={<CheckCircleOutline style={{ color: green[500] }} />} label={"Com."} />,
    2: <Chip variant="outlined" size="small" style={{ color: orange[500], borderColor: orange[500] }} icon={<InfoOutlined style={{ color: orange[500] }} />} label={"Parc."} />,
  },
};

const TestTable = ({ rows }) => {
  return (
    <Grid item xs={12} style={{ minHeight: "50vh" }}>
      {/*    } <DataGrid density="compact" rows={rows} columns={columns} pageSize={50} disableSelectionOnClick />*/}
      <TableContainer component={Paper} style={{ maxHeight: "98vh" }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell colSpan={3} align="left">
                Comunicaciones
              </TableCell>
              <TableCell colSpan={2} align="left">
                App
              </TableCell>
              <TableCell colSpan={3} align="left">
                Tiempos
              </TableCell>
              <TableCell colSpan={2} align="left">
                Permisos
              </TableCell>
              <TableCell colSpan={6} align="left">
                Dispositivo
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>UID</TableCell>
              <TableCell>Fecha</TableCell>
              <TableCell align="center">Estado</TableCell>
              <TableCell align="center">Inactivo</TableCell>
              <TableCell>Versión</TableCell>
              <TableCell align="center">Push</TableCell>
              <TableCell align="center">GPS</TableCell>
              <TableCell align="center">caché</TableCell>
              <TableCell align="right">2º Plano</TableCell>
              <TableCell align="right">Precisa</TableCell>
              <TableCell align="right">Ubic.</TableCell>
              <TableCell align="center">Alt. Pre</TableCell>
              <TableCell align="right">Batería</TableCell>
              <TableCell>Marca</TableCell>
              <TableCell align="right">OS</TableCell>
              <TableCell align="right">API</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.name} style={{ background: row.i % 2 == 0 && blueGrey[50] }}>
                <TableCell component="th" scope="row">
                  {/*<IconButton size="small" style={{ marginRight: 6 }}>
                    <FilterNone size="" />
            </IconButton>*/}
                  <Tooltip title={<Typography>{`${row?.email} token: ${row?.token}`}</Typography>} placement="top">
                    <Typography>{row?.uid?.slice(0, 6) + "..."}</Typography>
                  </Tooltip>
                </TableCell>
                <TableCell align="right">{moment(row.sendTime).format("HH:mm")}</TableCell>
                <TableCell align="right">{ROWVALUES.STATE[row.state]}</TableCell>
                <TableCell align="right">
                  {!!row.lastAppClosedTime && !!row.lastAppOpenTime
                    ? row.lastAppOpenTime > row.lastAppClosedTime
                      ? "En primer plano"
                      : moment().diff(moment(row.lastAppClosedTime), "days") +
                        " D y " +
                        moment()
                          .startOf("day")
                          .seconds((row.messageTime - row.lastAppClosedTime) / 1000)
                          .format("H:mm:ss")
                    : "-"}
                </TableCell>
                <TableCell align="center">{!!row.appVersion ? row.appVersion : "--"}</TableCell>
                <TableCell align="center">{!!row.messageTime ? parseInt(Math.abs(row.messageTime - row.sendTime) / 1000) + " s" : "?"}</TableCell>
                <TableCell align="center">{!!row.time && !!row.messageTime ? parseInt((row.time - row.messageTime) / 1000) + ` / ${row.GSPTimeOut}s` : "?"}</TableCell>
                <TableCell align="center">{!!row.maximumAge ? row.maximumAge : "--"} min</TableCell>
                <TableCell align="center">{ROWVALUES.ACCESS_BACKGROUND_LOCATION[row?.permmissions?.ACCESS_BACKGROUND_LOCATION]}</TableCell>
                <TableCell align="center">{ROWVALUES.ACCESS_FINE_LOCATION[row?.permmissions?.ACCESS_FINE_LOCATION]}</TableCell>
                <TableCell align="center">
                  {row.state == 0 ? <NotListedLocationOutlined /> : ROWVALUES.LOCATION_ENABLED[row.LocationEnabled](row.havePosition, row.position)}
                </TableCell>
                <TableCell align="center">{ROWVALUES.enableHighAccuracy[row.enableHighAccuracy]}</TableCell>
                <TableCell align="right">
                  <Grid container alignItems="center" justifyContent="flex-end" style={{ color: row.isCharging && green[500] }}>
                    {!isNaN(parseFloat(row.battery)) ? parseInt(row.battery * 100) + "%" : "-"}
                    {ROWVALUES.WHITELIST[row?.isInWhiteListOfBattery]}
                  </Grid>
                </TableCell>
                <TableCell align="center">{!!row.brand ? row.brand : "--"}</TableCell>
                <TableCell align="center">{ROWVALUES.OS[row.OS]}</TableCell>
                <TableCell align="center">{!!row.systemVersion ? row.systemVersion : "--"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  );
};

export default TestTable;
